import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { IAge } from "../../../../../../../application/models"
// Icon
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

export const RecorteIdadeFilterPreview = (props: {
    idadeFilter?: IAge
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Idade
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.idadeFilter && props.idadeFilter.min &&
                                <Chip
                                    key={0}
                                    icon={<CalendarMonthIcon />}
                                    label={`de: ${props.idadeFilter && props.idadeFilter.min} anos`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                            {props.idadeFilter && props.idadeFilter.max &&
                                <Chip
                                    key={1}
                                    icon={<CalendarMonthIcon />}
                                    label={`até: ${props.idadeFilter && props.idadeFilter.max} anos`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}